import { baseFetch } from 'src/utils';

/**
 *
 * @param cartId - the id of the cart to submit
 * @param layer - the NEW layer of the cart - will be 1 if it's the initial submission. If multi-layer approvals is on, this will be the current max layer + 1
 * @param approverId - the id of the approver to submit the cart to - required if org setting is on
 * @returns
 */
export const submitCartAPI = async (
  cartId: string,
  layer: number,
  approverId?: string,
) => {
  const body = {
    cartId,
    layer,
    ...(approverId && { approverId }),
  };

  const res = await baseFetch(`/api/org/cart-approvals`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error('Failed to submit cart');
  }

  const data = await res.json();

  if (!data.success) {
    throw new Error('Failed to submit cart');
  }

  return true;
};
